import ExploreIcon from '../assets/img/feature-statuses/tile_menu_icon_explore.png'
import ZingShopsIcon from '../assets/img/feature-statuses/tile_menu_icon_shop_online.png'
import ZingEatsIcon from '../assets/img/feature-statuses/tile_menu_icon_e_food.png'
import RewardsIcon from '../assets/img/feature-statuses/tile_menu_icon_rewards.png'
import EgiftIcon from '../assets/img/feature-statuses/tile_menu_icon_e_gift.png'
import TransportationIcon from '../assets/img/feature-statuses/tile_menu_icon_transportation.png'
import CinemasIcon from '../assets/img/feature-statuses/tile_menu_icon_cinemas.png'
import WifiIcon from '../assets/img/feature-statuses/tile_menu_icon_wifi.png'
import ParkingIcon from '../assets/img/feature-statuses/tile_menu_icon_parking.png'
import LoungeIcon from '../assets/img/feature-statuses/tile_menu_icon_lounge_pass.png'
import EconciergeIcon from '../assets/img/feature-statuses/tile_menu_icon_e_concierge.png'

export const APP_NAME = 'Ayala Malls Zing'

export const featureStatusesData = [
  {
    id: 1,
    description: '',
    imageUrl: ExploreIcon,
    itemCode: 'EXPLORE',
    orderNo: 0,
    status: 0,
    title: 'Explore',
  },
  {
    id: 8,
    description: 'string',
    imageUrl: ZingShopsIcon,
    itemCode: 'ZINGSHOPS',
    orderNo: 1,
    status: 0,
    title: 'ZingShops',
  },
  {
    id: 10,
    description: 'string',
    imageUrl: ZingEatsIcon,
    itemCode: 'ZINGEATS',
    orderNo: 2,
    status: 0,
    title: 'ZingEats',
  },
  {
    id: 2,
    description: '',
    imageUrl: RewardsIcon,
    itemCode: 'REWARDS',
    orderNo: 3,
    status: 0,
    title: 'Rewards',
  },
  {
    id: 3,
    description: '',
    imageUrl: EgiftIcon,
    itemCode: 'EGIFT',
    orderNo: 4,
    status: 0,
    title: 'Buy e-Gift',
  },
  {
    id: 5,
    description: 'Transaportation rename to P2P Guide',
    imageUrl: TransportationIcon,
    itemCode: 'TRANSPORTATION',
    orderNo: 6,
    status: 0,
    title: 'P2P Guide',
  },
  {
    id: 6,
    description: 'Buy your tickets via the Ayala Malls Cinemas ticket booth.',
    imageUrl: CinemasIcon,
    itemCode: 'CINEMAS',
    orderNo: 7,
    status: 1,
    title: 'Cinema',
  },
  {
    id: 4,
    description:
      'Please bear with us. Our WiFi service at Ayala Malls is on pause for now.',
    imageUrl: WifiIcon,
    itemCode: 'WIFI',
    orderNo: 8,
    status: 0,
    title: 'WiFi',
  },
  {
    id: 9,
    description: '',
    imageUrl: ParkingIcon,
    itemCode: 'PARKING',
    orderNo: 9,
    status: 0,
    title: 'Free Parking',
  },
  {
    id: 12,
    description: 'string',
    imageUrl: LoungeIcon,
    itemCode: 'LOUNGEPASS',
    orderNo: 10,
    status: 0,
    title: 'Lounge Pass',
  },
  {
    id: 7,
    description: '',
    imageUrl: EconciergeIcon,
    itemCode: 'ECONCIERGE',
    orderNo: 5,
    status: 0,
    title: 'eConcierge',
  },
]
